// @ts-check
import { simpleSet } from '@r/reducers/utils';
import { _ISimpleSet, AllActions } from '@r/storeUtils';

const s = simpleSet as _ISimpleSet<
  redux._IConstants['SET_DOOR_MATERIAL'],
  redux._IStore['projectFor3d']['doorMaterial'],
  AllActions
>;
export const doorMaterial = s( 'SET_DOOR_MATERIAL', { value: '', baseMap: '', label: '' } );
